// extracted by mini-css-extract-plugin
module.exports = {"root":"LookBoardsList_root__30b2X","item":"LookBoardsList_item__RdXdq"};